import React from "react";

const Footer = () => {
  return (
    <div className="pt-3 pb-3 bg-dark text-white text-center">
      <p>React Web Application Developed By Ashikur Rahman</p>
    </div>
  );
};

export default Footer;
